<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-card-actions>
          <v-row no-gutters>
            <v-col
              v-for="(item, i) in computedValue"
              :key="i"
              class="mb-2"
              cols="12"
            >
              <v-card
                class="rounded-lg d-flex align-center flex"
                outlined
                @click="editTableFunc(i)"
              >
                <v-avatar class="mx-2" size="42">
                  <v-img :src="item.image" cover />
                </v-avatar>
                <v-card-title
                  >{{ $t("manageTableReservation.table") }}
                  {{
                    item.name ||
                    $t("manageTableReservation.number", { num: i + 1 })
                  }}</v-card-title
                >
                <v-spacer />
                <v-btn class="rounded-lg mx-1" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>

                <v-btn
                  class="rounded-lg mx-1"
                  color="red"
                  icon
                  @click.stop="computedValue.splice(i, 1)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <help-info
                  left
                  :element-name="`${serviceName}-${componentName}-info-table`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('manageTableReservation.table')"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-card-actions>

        <v-card-actions>
          <div class="rowinfo" style="width: 100% !important">
            <v-btn
              class="rounded-lg contentinfo"
              color="green"
              outlined
              @click="openDialog"
            >
              <v-icon>mdi-plus</v-icon>
              {{ $t("manageTableReservation.add_table") }}
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-add-table`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('manageTableReservation.add_table')"
            />
          </div>
        </v-card-actions>

        <custom-popup
          v-model="dialog"
          :closeOnConfirm="false"
          :cons="cons"
          max-width="600"
          @close="resetFields"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-add-table-pop`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('manageTableReservation.add_table')"
            />
          </template>
          <v-card flat>
            <v-card-title>
              {{ $t("manageTableReservation.complete_info_for_customer") }}
            </v-card-title>

            <v-card-text v-if="dialog">
              <v-row no-gutters>
                <v-col class="py-2 px-0" cols="12">
                  <pic-selector
                    :edit-img="false"
                    :edit-name="false"
                    :field.sync="temp.image"
                    :default-cat-name="
                      $t('manageTableReservation.select_image')
                    "
                    one-pic
                    single
                  />
                </v-col>

                <v-col class="pa-2" cols="12" md="6">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="temp.name"
                      :error-messages="errors.name"
                      class="rounded-lg"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      :label="$t('manageTableReservation.table_name_number')"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-add-name`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('manageTableReservation.table_name_number')"
                    />
                  </div>
                </v-col>

                <v-col class="pa-2" cols="12" md="6">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="temp.seat"
                      class="rounded-lg contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      :label="$t('manageTableReservation.number_of_seats')"
                      outlined
                      type="number"
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-temp-seat`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('manageTableReservation.number_of_seats')"
                    />
                  </div>
                </v-col>

                <v-col class="pa-2" cols="12" md="6">
                  <div class="rowinfo">
                    <v-select
                      v-model="temp.type"
                      :items="types"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      :label="$t('manageTableReservation.type')"
                      outlined
                      :key="$i18n + 'select'"
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-temp-type`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('manageTableReservation.type')"
                    />
                  </div>
                </v-col>

                <v-col class="pa-2" cols="12" md="6">
                  <div class="rowinfo">
                    <price-input
                      v-model.number="temp.price"
                      class="rounded-lg contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      :label="$t('manageTableReservation.reservation_cost')"
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-temp-price`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('manageTableReservation.reservation_cost')"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </custom-popup>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";
import { mapState } from "vuex";
import PriceInput from "@/view/pages/uiBeautifier/priceInput.vue";

export default {
  name: "manageTableReservation",

  components: { PriceInput, PicSelector },

  props: {
    value: Object,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "manage-table-reservation",
      dialog: false,
      editTable: null,
      temp: {
        name: "",
        seat: "",
        image: "",
        type: "",
        price: 0,
        qr_id: null,
      },
      index: null,
      cons: {
        title: this.$t("manageTableReservation.add_table"),
        buttons: [{ type: "submit", handler: this.addTable }],
      },

      errors: {},
    };
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    types() {
      return [
        { value: "table", text: this.$t("manageTableReservation.table_type") },
        { value: "couch", text: this.$t("manageTableReservation.couch_type") },
        {
          value: "gazebo",
          text: this.$t("manageTableReservation.gazebo_type"),
        },
      ];
    },
    //   translatedTypes() {
    //     return this.types.map((type) => ({
    //       ...type,
    //       text: this.$t(`manageTableReservation.${type.value}`),
    //     }));
    //   },
  },
  watch: {
    "i18n.locale": {
      immediate: true,
      deep: true,
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    addTable() {
      if (!this.temp.name) {
        this.errors.name = this.$t("manageTableReservation.enter_table_name");
        this.$forceUpdate();
        return;
      }

      let obj = { ...this.temp, qr_id: this.createQrID };

      if (this.editTable != null) {
        this.computedValue[this.editTable] = this.temp;
      } else this.computedValue.push(obj);

      this.resetFields();
    },
    editTableFunc(index) {
      this.temp = this.computedValue[index];
      this.editTable = index;
      this.dialog = true;
    },
    resetFields() {
      this.dialog = false;
      this.editTable = null;
      this.temp = {
        name: "",
        seat: "",
        image: "",
        type: "",
        price: 0,
        qr_id: null,
      };
    },
  },
};
</script>

<style scoped>
/* Ensure RTL support for Persian and Arabic */
:deep(.v-application--is-rtl) {
  direction: rtl;
}
</style>
